<template>
  <div class="multimedia__content-grid">
    <chat-multimedia-empty
      v-if="isEmpty"
      :tab="$t('multimedia.locations')"
      :campaign="selectedCampaignName"
    />
    <div v-else>
      <div class="multimedia__campaign" v-if="isHistory">
        <span>
          {{ $t("multimedia.tab-from", { tab: $t("multimedia.locations") }) }}
        </span>
        <span class="multimedia__campaign-name"
          >{{ selectedCampaignName }}
        </span>
      </div>
      <div class="grid-x grid-margin-x grid-margin-y">
        <div
          v-for="(location, index) in locationsList"
          :key="index"
          class="cell small-12 medium-6 large-4"
        >
          <multimedia-location @selected="selectElement" :location="location" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MultimediaLocation from '@/components/multimedia/items/Location.vue';

export default {
  components: {
    MultimediaLocation,
    ChatMultimediaEmpty: () => import('@/components/ChatMultimediaEmpty.vue'),
  },
  props: {
    selectedCampaign: {
      type: [String, null],
    },
    selectedCampaignName: {
      type: [String, null],
    },
  },
  computed: {
    ...mapGetters([
      'activeConversation',
      'activeConversationHistory',
      'dataBankLocations',
    ]),
    conversation() {
      return !this.isHistory
        ? this.activeConversation.conversation
        : this.activeConversationHistory.conversation;
    },
    campaignId() {
      return this.conversation.campaign.id;
    },
    locationsList() {
      return this.dataBankLocations({
        campaignId: this.selectedCampaign,
      });
    },
    isEmpty() {
      return this.locationsList.length === 0;
    },
  },
  methods: {
    selectElement(location) {
      this.$emit('data-bank-picked', location);
    },
  },
};
</script>
